import React from 'react'

import { Avatar, Button, Typography, Divider, Switch } from '@mui/material'
import { Box, styled } from '@mui/system'

import { convertToPersianNumber, convertHourToPersianDigit } from 'utils';
import { ArrowLeftIcon, ClockIcon } from 'Sui_Icons';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { confirmDialog } from 'components/ConfirmDialog/ConfirmDialog';


const Tag = styled(Box)({
    backgroundColor: 'rgba(5, 198, 197, 0.1)',
    borderRadius:'5px',
    color: '#05C6C5',
    fontSize: '12px',
    padding: '4px',
    width: 'fit-content',
    '&:not(:last-child)': {
        marginRight: '8px'
    }
})

let URL;
if (process.env.NODE_ENV === "production") {
    URL = `${process.env.REACT_APP_PRODUCTION_API_URL}`;
} else {
    URL = `${process.env.REACT_APP_DEVELOPMENT_API_URL}`;
}

export const BlogCard = ({ img, title, caption, length, id ,visible , onVisible , onDelete , index}) => {

    return (
        <Box sx={{ px: { xs: 4, lg: 2 }, py: 2, display: 'flex', flexDirection: 'column', background: 'white', borderRadius: 2, position: 'relative', bottom: 0, transition: 'all ease 0.4s', color: 'CaptionText' }} component={'a'} >
            <Box sx={{ borderRadius: 1.1, mb: 2, position: 'relative', overflow: 'hidden', display: 'flex', justifyContent: 'center' }}>
                <Box sx={{ height: { xs: '180px', lg: '170px' }, width: { xs: '100%', lg: '100%' } }}><img style={{ width: '100%', height: '100%', borderRadius: '9px' }}                          
                    src={`${URL}/api/v1/${img}`} />
                </Box>
            </Box>

            <Typography gutterBottom fontSize={14} fontWeight={'bold'} >{title}</Typography>

            <Typography gutterBottom color='grey.600' fontSize={13}>{caption.length > 30 ? caption.substr(0, 30) + '...' : caption}</Typography>

            <Divider />

            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Typography fontSize={14} fontWeight={'medium'}>قابل رویت</Typography>
                    &nbsp;&nbsp;
                    <Switch color='primary'
                     checked={visible} 
                     onChange={()=>onVisible(id)} 
                     />
                </Box>
            </Box>


            <Box sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                borderRadius: 1,
                py: 1.5,
                px: 1,
            }}>
                <Button color='error' variant='text' onClick={()=>onDelete(id, true)} startIcon={<DeleteOutlineIcon color='error' />}>
                    <Typography color='error.main' fontSize={13} fontWeight={500}>
                        حذف
                    </Typography>
                </Button>

                <Button href={`edit/${id}`} endIcon={<ArrowLeftIcon size={'25px'} />}><Typography color='primary.main' fontWeight={700} fontSize={14}>ویرایش بلاگ</Typography></Button>

            </Box>

        </Box>
    )

}
